module.exports = __webpack_public_path__ + "img/texto-derecha.bd9b953e.jpg";